import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Segment } from '../../services/analytics-services/segment';
import Global from '../../store/global-selectors';
import { toggleSidebarVisibility } from '../../store/orders/grid/orders.grid.actions';
import { EXPERIMENT_VIEWED } from '../../constants/analytics-events';
import { GO_TO_ORDERS_WITH_AUTOMATION_HIDE_SIDEBAR } from '../../feature-flags/hooks/use-enable-grow-518-experiment';

const GROW_518 = 'GROW_518';

export const useTrackGrow518Experiment = ({ variant }) => {
  const dispatch = useDispatch();
  const sellerId = useSelector(Global.selectSellerSellerId)?.toString();
  const userId = useSelector(Global.selectUserCurrentUserId);

  return useCallback(async () => {
    if (variant === GO_TO_ORDERS_WITH_AUTOMATION_HIDE_SIDEBAR) {
      dispatch(toggleSidebarVisibility());
    }

    Segment.trackEvent(EXPERIMENT_VIEWED, {
      experiment_id: GROW_518,
      group_variation: variant,
      seller_id: sellerId,
      user_id: userId,
      enrollment_date: new Date(),
    });
  }, [dispatch, sellerId, userId, variant]);
};
